import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {API} from '../../../../../@core/http/config/api';
import {IConsignmentLog} from '../../../../../@core/http/consignment-actions/models';
import {Subject} from 'rxjs';

@Injectable()
export class ConsignmentLogService {
  constructor(private httpClient: HttpClient) {
  }

  private consignmentId;
  private isLoading = false;

  private consignmentLogSubject: Subject<IConsignmentLog[]> = new Subject();
  public consignmentLogs = this.consignmentLogSubject.asObservable();
  private currentLogs: IConsignmentLog[] = [];

  storeConsignment(id) {
    this.consignmentId = id;
    this.clearLocalData();
    this.loadMore();
  }

  loadMore() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.httpClient.get<IConsignmentLog[]>(API.CONSIGNMENT_LOG.GET_LOG(this.consignmentId))
      .subscribe(data => {
        this.currentLogs.push(...data);
        this.consignmentLogSubject.next(this.currentLogs);
      }, er => {

      }, () => {
        this.isLoading = false;
      });
  }

  private clearLocalData() {
    this.isLoading = false;
    this.currentLogs = [];
  }
}
